import React from "react";
import "./FinanceHelp.scss";

const FinanceHelp = () => {
  return (
    <div className="finance-help-main">
      <div className="finance-help-left">
        <button>CONTACT US</button>
        <h2>Let's Work Together</h2>
        <p>
          We condemn with rightful anger and, like those who have <br></br>been
          misled and corrupted by allurements.
        </p>
        <div className="finance-help-left-call-section">
          <div className="finance-help-left-call">
            <div className="finance-help-left-call-icon">
              <span class="material-symbols-outlined">perm_phone_msg</span>
            </div>
            <div className="finance-help-left-inquiry">
              <p>Call For Inquiry</p>
              <h2>+00 (002) 896 22</h2>
            </div>
          </div>
          <div className="finance-help-left-call">
            <div className="finance-help-left-call-icon">
              <span class="material-symbols-outlined">mail</span>
            </div>
            <div className="finance-help-left-inquiry">
              <p>Send Us Email</p>
              <h2>theme@gmail.com</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="finance-help-right">
        <div className="finance-help-form-container">
          <h2>Need Help For Project!</h2>
          <p>let's collaborate and create something amazing together!</p>
          <div className="finance-help-input-container">
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Email Address" />
          </div>
          <select name="choose our services" id="">
            <option value="">Choose Our Services</option>
            <option value="">UI/UX Design</option>
            <option value="">Web Developer</option>
            <option value="">Marketing Manager</option>
            <option value="">Web Designer</option>
            <option value="">Financial Advice</option>
          </select>
          <textarea name="" id="">
            Write a Message
          </textarea>
          <button>
            Send Message Us{" "}
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinanceHelp;
